import { useNavigate } from "react-router-dom";

export const useOpenRoute = () => {
  const navigate = useNavigate();

  return (path, event) => {
    if (!path) return;

    const isNewTab =
      event?.metaKey ||
      event?.ctrlKey ||
      event?.button === 1;

    if (isNewTab) {
      event?.preventDefault?.();
      window.open(path, "_blank", "noopener,noreferrer");
      return;
    }

    navigate(path);
  };
};